[
    [1,1,"כללי:",0  ],
    [2,1,"איכות הדמיה בינונית",1  ],
    [3,1,"במהלך הבדיקה פרפור פרוזדורים",1  ],
    [4,1,"במהלך הבדיקה פעימות מוקדמות מרובות",1  ],
    [5,1,"חדר שמאל בגודל ותפקוד תקינים. חדר ימין בגודל ותפקוד תקינים. מסתמי הלב תקינים במבנה ותפקוד. לחץ ריאתי תקין, עליות הלב תקינות",1  ],
    [6,1,"בדיקת אקו דופלר תקינה",1  ],
    [7,1,"חדר שמאל וימין",0  ],
    [8,1,"חדר שמאל בגודל ותפקוד תקינים.חדר ימין בגודל ותפקוד תקינים.",7  ],
    [9,1,"חדר ימין בגודל ותפקוד תקינים",7  ],
    [10,1,"חדר שמאל וימין בגודל ותפקוד תקינים",7  ],
    [11,1,"חדר שמאל בגודל תקין, תפקודו הסיסטולי הגלובלי תקין ללא הפרעה אזורית מקטע פליטה מוערך  , תבנית המילוי הדיאסטולי תקינה , עליות בגודל תקין",7  ],
    [12,1,"לא הודגמה הפרעה סגמנטרית משמעותית בהתכווצות",7  ],
    [13,1,"הודגמה אקינזיה בסגמנטים",7  ],
    [14,1,"פוסטריורית",7  ],
    [15,1,"אינפריורית",7  ],
    [16,1,"אנטריורית",7  ],
    [17,1,"ספטלית",7  ],
    [18,1,"לטרלית",7  ],
    [19,1,"אפיקלית",7  ],
    [20,1,"התכווצות שאר האיזורים תקינה, מקטע פליטה מעורך",7  ],
    [21,1,"תפקודו הגלובלי מופחת במידה קלה ; מקטע פליטה מוערך בכ ",7  ],
    [22,1,"חדר שמאל קיימת ירידה דיפוזית קשה בהתכווצות הדפנות.תפקוד המקטעים  הבזליים טוב יותר תפקודו הכללי  מופחת במידה קשה.מקטע פליטה מוערך ",7  ],
    [23,1,"הודגמה ירידה דיפוזית בתנועתיות הדפנות",7  ],
    [24,1,"חדר שמאל תקין בגודלו ,תפקודו הסיסטולי הגלובלי מופחת במידה קלה ,הודגמה אקינזיה",7  ],
    [25,1,"חדר שמאל מורחב ,תפקודו הסיסטולי הגלובלי",7  ],
    [26,1,"מפל לחצים דינמי באפיק המוצא של חדר שמאל העולה מכ- ממ\"כ במנוחה לכ- ממ\"כ לאחר ואלסלווה.",7  ],
    [27,1,"מחיצות הלב ",0  ],
    [28,1,"הודגמה התעבות גבולית של המחיצה הבינחדרית",27  ],
    [29,1,"הודגמה התעבות ממוקמת של המחיצה הבינחדרית הפרוקסימלית",27  ],
    [30,1,"לא הודגמה חסימה דינמית באפיק המוצא של חדר שמאל",27  ],
    [31,1,"הודגמה התעבות קונצנטרית של הדפנות",27  ],
    [32,1,"תנועת המחיצה  אסינכרונית מתאימה ל-LBBB",27  ],
    [33,1,"מחיצות הלב תקינות",27  ],
    [34,1,"מחיצות הלב תקינות מוצא העורקים הכליליים תקין",27  ],
    [35,1,"מחיצה בין עלייתית תקינה",27  ],
    [36,1,"נמצאה הרחבה אנאוריזמטית של המחיצה הבין-עליתית; לא הודגם מעבר דרך המחיצה.",27  ],
    [37,1,"נמצא patent foramen ovale עם דלף קטן משמאל לימין.",27  ],
    [38,1,"מסתמים:",0  ],
    [39,1,"מסתמי הלב תקינים במבנה ובתפקוד.",38  ],
    [40,1,"מסתמי הלב ללא הפרעה מבנית משמעותית .",38  ],
    [41,1,"מבנה ותפקוד המסתמים ללא הפרעה מבנית משמעותית הודגמו  דלף מיטרלי וטריקוספידלי טריוויאליים  ללא עדות לתפליט פריקרדיאלי",38  ],
    [42,1,"מבנה תקין של שאר המסתמים.",38  ],
    [43,1,"מסתם מיטרלי",38  ],
    [44,1,"מסתם מיטרלי עלה קידמי מעובה במידה קלה בקצהו עם דלף קל.",43  ],
    [45,1,"מסתם מיטרלי תקין , הודגמה הסתיידות של טבעת המסתם",43  ],
    [46,1,"דלף מיטרלי פיזיולוגי",43  ],
    [47,1,"דלף מיטרלי טריויאלי",43  ],
    [48,1,"מסתם מיטרלי : תקין, טבעת המסתם מיטרלי מסויידת ,ללא הצרות ,הודגם דלף מיטרלי",43  ],
    [49,1,"מסתם מיטרלי : הודגמה צניחה של העלה האחורי, הודגם דלף",43  ],
    [50,1,"מסתם מיטרלי : עליו מעובים ,מפל לחצים על פניו : מקסימלי ממ\"כ ממוצע ממ\"כ שטח המסתם מחושב ממ\"כ .",43  ],
    [51,1,"הודגמה צניחה של העלה האחורי המסתם המיטרלי (MVP).",43  ],
    [52,1,"הודגם קרע של העלה ה של המסתם המיטרלי. הודגם דלף ",43  ],
    [53,1,"הודגם כיפוף של העלה הקדמי של המסתם המיטרלי ללא קריטריונים של MVP. עלי המסתם לא מעובים.",43  ],
    [54,1,"המסתם המיטרלי ; פתיחתו מוגבלת; הודגמה היצרות מיטרלית קלה ודלף מיטרלי .",43  ],
    [55,1,"המסתם המיטרלי ; פתיחתו מוגבלת; הודגמה היצרות מיטרלית קשה ודלף מיטרלי",43  ],
    [56,1,"המסתם המיטרלי לאחר תיקון; תפקודו תקין.",43  ],
    [57,1,"מסתם מיטרלי תותב תפקודו תקין.מפל לחצים  ",43  ],
    [58,1,"הודגמה תנועת SAM של העלה הקדמי, מפל לחצים נמדד באפיק המוצא של חדר שמאל במנוחה ובוולסלווה",43  ],
    [59,1,"מסתם אאורטלי",38  ],
    [60,1,"מסתם אאורטלי-תלת עלי תקין",59  ],
    [61,1,"מסתם אאורטלי תלת עלי מעובה במידה קלה ללא היצרות ללא דליפה.",59  ],
    [62,1,"דלף אאורטלי טריוויאלי",59  ],
    [63,1,"מסתם האאורטלי מסוייד ,מפל לחצים מוגבר על פניו ,מקסימלי ממ\"כ ממוצע ממ\"כ ,שטח המסתם מחושב סמ\"ר , LVOT DIAM  ס\"מ",59  ],
    [64,1,"מסתם האאורטלי מסויד ,ללא הצרות ,הודגם דלף טריוויאלי ",59  ],
    [65,1,"המסתם האאורטלי מסויד; פתיחתו מוגבלת; הודגמה היצרות אאורטלית בינונית ודלף אאורטלי",59  ],
    [66,1,"המסתם האאורטלי מסויד; פתיחתו מוגבלת; הודגמה היצרות אאורטלית קלה ודלף טריוויאלי ",59  ],
    [67,1,"מסתם אאורטלי תותב תפקודו תקין מפל לחצים ",59  ],
    [68,1,"מסתם טריקוספידלי וריאתי",38  ],
    [69,1,"מסתם טריקוספידלי תקין",68  ],
    [70,1,"מסתם טריקוספידלי תקין הודגם דלף טריקוספידלי פיזיולוגי , לחץ ריאתי תקין ",68  ],
    [71,1,"הודגם דלף טריקוספידלי פיזיולוגי , לחץ ריאתי תקין ממ\"כ+RAP",68  ],
    [72,1,"הודגם דלף טריקוספידלי טריוויאלי , לחץ ריאתי תקין ממ\"כ+RAP",68  ],
    [73,1,"מסתם טריקוספידלי תקין, לא ניתן להעריך את הלחץ הריאתי בהיעדר אות ברור של TR",68  ],
    [74,1,"עדות ליתר לחץ דם ראתי בינוני; הלחץ הסיסטולי בעורק הראה מוערך ב - ממ\"כ.",68  ],
    [75,1,"עדות ליתר לחץ דם ראתי קשה; הלחץ הסיסטולי בעורק הראה מוערך ב - ממ\"כ.",68  ],
    [76,1,"מסתם ריאתי תקין",68  ],
    [77,1,"עליות הלב",0  ],
    [78,1,"עליות הלב תקינות",77  ],
    [79,1,"עליה שמאלית בגודל  תקין.",77  ],
    [80,1,"עליה שמאלית מוגדלת במידה קלה",77  ],
    [81,1,"עליה ימנית תקינה",77  ],
    [82,1,"עליה ימנית מוגדלת",77  ],
    [83,1,"אאורטה ",0  ],
    [84,1,"שורש אאורטה ואאורטה עולה תקינים",83  ],
    [85,1,"שורש האאורטה ברוחב תקין.",83  ],
    [86,1,"שורש האאורטה ברוחב תקין; האאורטה העולה מורחבת במידה ",83  ],
    [87,1,"שורש אאורטה ואאורטה מורחבות במידה",83  ],
    [88,1,"הרחבה של שורש האאורטה ושל האאורטה העולה.",83  ],
    [89,1,"קשת האאורטה .",83  ],
    [90,1,"אאורטה הבטנית תקינה",83  ],
    [91,1,"זרימה תקינה על פני האאורטה היורדת. ",83  ],
    [92,1,"תפליט פריקרדיאלי",0  ],
    [93,1,"לא הודגם תפליט פריקרדיאלי.",92  ],
    [94,1,"הודגם תפליט פריקרדיאלי בכמות מזערית.",92  ],
    [95,1,"הודגם תפליט פריקרדיאלי בכמות קטנה.",92  ],
    [96,1,"הודגם תפליט פריקרדיאלי בכמות בינונית.",92  ],
    [97,1,"הודגם תפליט פריקרדיאלי בכמות גדולה.",92  ],
    [98,1,"ללא משמעות המודינמית, ללא סימני לחץ על חדר ימין, ללא שינוי משמעותי בתרשימי הזרימה על פני המסתם המיטראלי",92  ],
    [99,1,"הודגם תסנין שומני פריקרדיאלי pericardial fat ",92  ],
    [100,1,"לחצי מילוי",0  ],
    [101,1,"לחצי מילוי תקינים",100  ],
    [102,1,"לחצי מילוי מתאימים להפרעה בהרפייה דרגה",100  ],
    [103,1,"לחצי מילוי A=E",100  ],
    [104,1,"גל A גבוה מגל E בעקומת המילוי של החדר השמאלי כביטוי להפרעה בהרפיה דרגה 1",100  ],
    [105,1,"עקומת המילוי של החדר השמאלי בעלת תבנית רסטריקטיבית.",100  ],
    [106,1,"עקומת המילוי של החדר השמאלי בעלת תבנית פסאודו-נורמלית.",100  ],
    [107,1,"הפרעה בהרפיה דרגה",100  ],
    [108,1,"לא ניתן להעריך את התפקוד הדיאסטולי",100  ],
    [109,1,"לחצי מילוי  , MV E/A RATIO=  ,MV DECT    ms ,E/e' lateral=  ,E/e' septal , כביטוי להפרעה בהרפיה דרגה",100  ],
    [110,1,"מחיצות הלב",0  ],
    [111,1,"תקינות",110  ],
    [112,1,"הודגם PFO ",110  ],
    [113,1,"הודגמה אנוריזמה של המחיצה הבינעליתית ללא דלף",110  ],
    [114,1,"תנועתיות יתר של המחיצה הבינעליתית ללא דלף",110  ],
    [115,1,"עם דלף קטן משמאל לימין",110  ],
    [116,1,"הודגם ASD",110  ],
    [117,1,"מחיצה בינחדרית תקינה",110  ],
    [118,1,"הודגם VSD ",110  ],
    [119,1,"הודגם VSD קטן עם זרימה משמאל לימין מפל לחצים מקסימלי      ממ\"כ",110  ],
    [120,1,"ממצאים ומסקנות",0  ],
    [121,1,"בדיקת אקודופלר של הלב תקינה",120  ],
    [122,1,"בדיקת אקו דופלר של הלב בתחום התקין",120  ],
    [123,1,"הממצאים המתוארים הם ללא משמעות המודינמית או קלינית ומצוינים לצורכי תיעוד",120  ],
    [124,1,"הממצא המתואר ללא משמעות המודינמית או קלינית ומצוין לצרכי תיעוד",120  ],
    [125,1,"לא הודגמו וגיטציות",120  ],
    [126,1,"לא הודגם מקור קרדיאלי לתסחיפים",120  ],
    [127,1,"ללא שינוי מהותי מהבדיקה",120  ],
    [128,1,"ממצאי הבדיקה הוסברו לנבדק",120  ],
    [129,1,"אין עדות ליתר לחץ דם ראתי",120  ],
    [130,1,"המלצות ",0  ],
    [131,1,"מומלצת בקורת שגרתית בעוד",130  ],
    [132,1,"בבדיקה זו הודגמו ממצאים העשויים להשפיע על האבחנה",130  ],
    [133,1,"יש לפנות עם תשובה זו לרופא המפנה בהקדם",130  ],
    [134,1,"מומלץ להשלים הערכה על ידי בדיקת אקו במאמץ",130  ],
    [135,1,"אבחנות עיקריות",130  ],
    [136,1,"ECHOCARDIOGRAM DIAGNOSTIC FINDINGS",135  ],
    [137,1,"ECHOCARDIOGRAM NON SIGNIFICANT FINDINGS",135  ],
    [138,1,"ECHOCARDIOGRAM NORMAL",135  ],
    [139,1,"הממצאים מתאימים",135  ],
    [140,1,"הממצאים מתאימים להצרות אאורטלית",135  ],
    [141,1,"Hypertrophic non-obstructive cardiomyopathy",135  ],
    [142,1,"Dilated ischemic cardiomyopathy.",135  ]
  ]